import React from 'react'

export default function AllPackagesEnquiryList() {
  return (
    <div>
      AllPackagesEnquiryList
    </div>
  )
}
